import Role from "@higher/models/Role";
import { stateSubscriptionById } from "./stateSubscriptionById";

const RolesCollection = "roles";

export default stateSubscriptionById<Role>("RoleById", RolesCollection);
